// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"MenuBlock_menuBlock__1xxKq"};